export default "/images/transp.svg?52cedaa692b6648ec1aa070b7a6fec79";